import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../login/AccessToken";
import { IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import "./LabTest.scss";
import { displayPatientName } from "../../utils/displayPatientName";
import LabLayout from "./LabLayout";
import IpdLabOrders from "./IpdLabOrders";
import { C, getAuthHeaders } from "../ipd-billing/constants";
import { PageHeader } from "../rule-builder/ui";

function PatientTypeTabs({ value, onChange }) {
  const tabs = [
    { id: "ALL", label: "All" },
    { id: "OPD", label: "OPD" },
    { id: "IPD", label: "IPD" },
    { id: "EMERGENCY", label: "Emergency" },
  ];
  return (
    <div
      style={{
        display: "inline-flex",
        gap: 4,
        background: "#eef1f4",
        borderRadius: 10,
        padding: 4,
        marginBottom: 20,
      }}
    >
      {tabs.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "8px 16px",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: 700,
              background: active ? "#fff" : "transparent",
              color: active ? C.text : C.textSub,
              boxShadow: active ? "0 1px 3px rgba(13,35,63,0.12)" : "none",
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

function LabTest() {
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") || "",
  );
  const [modalNewAddOpen, setNewAddModalOpen] = useState(false);
  const [patientList, setPatientList] = useState("");
  const [patientTypeTab, setPatientTypeTab] = useState("ALL");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const closeNewAddModal = () => {
    setNewAddModalOpen(false);
  };
  const history = useHistory();
  const headers = getAuthHeaders();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    if (sessionStorage.getItem("roleType") === "lab user" && CheckToken()) {
      fetchPatientList();
    }
  }, [authToken]);

  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const fetchPatientList = () => {
    if (Token()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          },
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  };

  const handleSubmitNewAdd = (data) => {
    console.log("data", data);
    const requestData = {
      patient_id: "PAT_70",
      facility_id: "HLTHTEK_DEV",
      appointment_id: "appointment-6",
      doctor_id: "daed401c-0c02-45b8-beac-25e72cfb1edb",
      doctor_name: "Dr. Debjit Mondal",
      care_context_id: "REF-4jui29",
      test: ["Complete Blood Test", "Thyroid Function Test"],
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_patient_lab_tests/`,
        requestData,
        { headers: headers },
      )
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log("FETCH FAILED:", error);
      });
  };

  return (
    <LabLayout>
      <div style={{ padding: "28px 32px" }}>
        <PageHeader
          title="Tests and Examinations"
          subtitle="Patient lab orders · status tracking · record uploads"
        />

        <PatientTypeTabs
          value={patientTypeTab}
          onChange={setPatientTypeTab}
        />

        <IpdLabOrders patientTypeFilter={patientTypeTab} />
      </div>

      <Modal
        open={modalNewAddOpen}
        onClose={closeNewAddModal}
        style={{ overflowY: "auto" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "15px",
          }}
        >
          <div
            className="col-sm-12 col-md-12 col-lg-7"
            style={{ marginLeft: "22%" }}
          >
            <div className="contact-panel mb-50">
              <IconButton
                onClick={closeNewAddModal}
                style={{ position: "absolute", top: 0, right: 0 }}
              >
                <CloseIcon />
              </IconButton>
              <form
                className="contact-panel__form"
                onSubmit={handleSubmit(handleSubmitNewAdd)}
              >
                <div className="row">
                  {patientList && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="patientId" className="required-label">
                          Patient{" "}
                        </label>
                        <select
                          className="form-control"
                          name="patient_id"
                          {...register("patient_id", {
                            required: "Patient ID is required.",
                          })}
                        >
                          <option value="" disabled>
                            Select Patient
                          </option>
                          {patientList.map((patient) => (
                            <option
                              key={patient.patient_id}
                              value={patient.patient_id}
                            >
                              {displayPatientName(patient.name)}
                            </option>
                          ))}
                        </select>
                        {errors.patientId && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.patientId.message}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="first_name" className="required-label">
                        First Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter First Name"
                        name="first_name"
                        {...register("first_name", {
                          required: "First Name is required.",
                        })}
                      />
                      {errors.first_name && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors.first_name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="last_name" className="required-label">
                        Last Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Last Name"
                        name="last_name"
                        {...register("last_name", {
                          required: "Last Name is required.",
                        })}
                      />
                      {errors.last_name && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors.last_name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label
                        htmlFor="serviceRequest"
                        className="required-label"
                      >
                        Test And Procedure
                      </label>
                      <textarea
                        {...register("testAndProcedure", {
                          required: "Service Request is required",
                        })}
                        className="form-control"
                        placeholder="Enter Test And Procedure (Separate items with comma)"
                      />
                      {errors.testAndProcedure && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors.testAndProcedure.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </LabLayout>
  );
}

export default LabTest;
